export default "__VITE_ASSET__BXcXR5EA__"